import React from "react";
import "./ParentingCorner.css";
import { parenting_articles } from "../../../config/constants";
import ArticleCard from "../../../theme/articleCard/ArticleCard";

const ParentingCorner = () => {
  return (
    <section className="container parenting-corner-container">
      <h3 className="parenting-corner-section-name">Parenting Corner</h3>
      <div className="inner-container-first parenting-articles-container">
        <div className="scrollable-inner">
          {/* to avoid scrollbar spilling out of border radius of container */}
          <ul className="article-list">
            {parenting_articles.map((article, index) => (
              <li key={index}>
                <ArticleCard
                  title={article.headline}
                  summary={article.summary}
                  link={article.link}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ParentingCorner;
